import React from 'react';
import {
  BillingDashboardTabName,
  TableData,
  Transaction,
  TransactionResponse,
} from '../billing-admin-home/BIllingAdminConstant';
import BillingAdminHomeTable from '../billing-admin-home/BillingAdminHomeTable';
import '../billing-admin-home/BillingAdminHome.scss';
import PaginationController from 'src/latest/src/components/PaginationController';
import { noop } from 'lodash';
import { Typography } from 'src/latest/src/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PopAheadSearch from 'src/latest/src/components/PopAheadSearch';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

interface PatientTransactionProps {
  loading: boolean;
  isDirectoryPlatform: boolean;
  transactionData: TransactionResponse | null;
  handleTransactionSort: (key: string) => void;
  activeTab: BillingDashboardTabName;
  transactionTotalPages: number;
  transactionCurrentPage: number;
  handleTransactionPageChange: (page: number) => void;
  transactionHeaderData: TableData[];
  totalCount: number;
  handleSearchInputChange: (searchText: string) => void;
  handleRefundClick: (transaction: Transaction) => void;
}

const PatientTransaction: React.FC<PatientTransactionProps> = ({
  loading,
  isDirectoryPlatform,
  transactionData,
  handleTransactionSort,
  activeTab,
  transactionTotalPages,
  transactionCurrentPage,
  handleTransactionPageChange,
  transactionHeaderData,
  totalCount,
  handleSearchInputChange,
  handleRefundClick,
}) => {
  return (
    <>
      <div className="billing-admin-dashboard-header d-flex justify-content-between">
        <div className="billing-admin-dashboard-header-text">
          <Typography
            weight="semi-bold"
            className="billing-admin-dashboard-header-text"
            variant="size-20"
          >
            Recent Transactions
          </Typography>
          <Typography variant="size-14" color="color-4">
            {totalCount} in Total{' '}
            <FontAwesomeIcon
              size="sm"
              icon={faCircleInfo}
              style={{ color: '#828991' }} // need to use inline here for FontAwesomeIcon constraints
            />
          </Typography>
        </div>
        <div className="billing-admin-dashboard-search d-flex justify-content-center">
          <PopAheadSearch
            key={activeTab}
            id={'user-search'}
            onSearch={handleSearchInputChange}
            placeholder={'Search Transaction'}
          />
        </div>
      </div>
      <BillingAdminHomeTable
        headerData={transactionHeaderData}
        loading={loading}
        activeTab={activeTab}
        isDirectoryPlatform={isDirectoryPlatform}
        onSort={handleTransactionSort}
        noDataFound={!loading && !transactionData?.transactions?.length}
        patientData={undefined}
        directoryPatientData={undefined}
        transactionData={transactionData?.transactions || []}
        chargingPatientId={null}
        searchIds={null}
        handlePatientDetailClick={noop}
        handleDirectoryPatientDetailClick={noop}
        handleChargeClick={noop}
        handleDirectoryChargeClick={noop}
        handleRefundClick={handleRefundClick}
        totalCount={
          transactionData?.totalCount || transactionData?.pagination?.total || 0
        }
        fromPatientDetailsPage={true}
        fromAccountInformationPage={false}
      />
      {transactionTotalPages > 1 && (
        <div className="mt-4">
          <div className="pagination-section">
            <div className="d-flex justify-content-center pagination_container">
              <PaginationController
                totalNoOfPages={transactionTotalPages}
                activePage={transactionCurrentPage - 1}
                onPageChange={handleTransactionPageChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PatientTransaction;
